const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.proxyflash.net';

/**
 * Simple fetch from API without caching
 * @param endpoint - API endpoint (e.g., '/api/public/landing/cards')
 * @returns Promise with the data
 */
export async function fetchApi<T>(endpoint: string): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`API request failed: ${response.statusText}`);
  }

  return response.json();
}

export { API_BASE_URL };
